import TypesenseInstantSearchAdapter, {
  BaseSearchParameters
} from 'typesense-instantsearch-adapter';

export type TypesenseSearchConfig = {
  indexName?: string;
  apiKey: string;
  host: string;
  port: number;
  protocol?: string;
};

export const getTypesenseSearchClient = (
  additionalSearchParameters: BaseSearchParameters,
  config: TypesenseSearchConfig
) => {
  const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: {
      apiKey: config.apiKey,
      nodes: [
        {
          host: config.host,
          port: config.port,
          protocol: config.protocol || 'http'
        }
      ],
      cacheSearchResultsForSeconds: 2 * 60
    },

    additionalSearchParameters
  });

  return typesenseInstantsearchAdapter.searchClient;
};
